import { grabCounts, grabPayPeriods } from "../dataLayer/home"; 

class HomeManager {

    // Method to get timesheet counts based on pay period ID and supervisor ID
    async getTimesheetCounts(payPeriodID: number, supervisorID: number): Promise<any> {
        try {
            // Fetch the timesheet counts using the provided payPeriodID and supervisorID
            const authData = await grabCounts(payPeriodID, supervisorID);

            // Log the successful retrieval of timesheet counts for debugging purposes
            console.log("Grab successful:", authData);

            // Return the timesheet counts data
            return authData;

        } catch (error) {
            // Log any errors that occur during the fetching of timesheet counts
            console.error("Error during grabbing counts:", error);

            // Rethrow the error to be handled by the calling code
            throw error;
        }
    }

    // Method to fetch the available pay periods
    async fetchPayPeriods(): Promise<any> {
        try {
            // Fetch the available pay periods
            const authData = await grabPayPeriods();

            // Log the successful retrieval of pay periods for debugging purposes
            console.log("Grab successful:", authData);

            // Return the pay periods data
            return authData;

        } catch (error) {
            // Log any errors that occur during the fetching of pay periods
            console.error("Error during fetching pay periods:", error);

            // Rethrow the error to be handled by the calling code
            throw error;
        }
    }

}

// Export a single instance of HomeManager to be used across the application
export default new HomeManager();
